import { FC, useState } from 'react';
import { Page, PageTitle } from '../../../components';
import { BuildCommunicationsList } from './build-communications-list';
import { FormControlLabel, Switch } from '@mui/material';

export const BuildCommunications: FC = () => {
  const [openBuilds, setOpenBuilds] = useState<boolean>(true);

  const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setOpenBuilds(event.target.checked);
  };

  return (
    <Page title="Build Communications" showSideBar={false} sideBarLinks={[]}>
      <PageTitle
        title="Build Communications"
        additionalHeaderContent={
          <FormControlLabel
            control={
              <Switch
                color="primary"
                id="open-builds-toggle"
                checked={openBuilds}
                onChange={handleSwitchChange}
              />
            }
            label="Open Builds"
          />
        }
      />
      <BuildCommunicationsList openBuilds={openBuilds} />
    </Page>
  );
};
